module.exports = __webpack_public_path__ + "img/HN.8563e78d.svg";